import { NotificationsNone } from "@mui/icons-material";
import { Badge, Box, IconButton } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { APIRoutes } from "../../../constants";
import { getUserId } from "../../../utils/role";
import { HOSTURL_LOCAL, RequestServer } from "../../../utils/services";
import NotificationsList from "./NotificationsList";
import { useSnackbar } from "notistack";

export default function Notifications() {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const url = useMemo(() => {
    return (
      APIRoutes.NOTIFICATIONS + "?limit=100" + "&sort_by=desc___created_at"
    );
  }, []);

  useEffect(() => {
    let eventsource: EventSource | null = null;
    let reconnectFrequencySeconds = 1;
    let reconnectAttempts = 0;
    const maxReconnectAttempts = 2;

    const reconnect = () => {
      if (reconnectAttempts >= maxReconnectAttempts) {
        console.error("Maximum reconnection attempts reached. Closing EventSource.");
        return;
      }
      reconnectAttempts++;
      reconnectFrequencySeconds = Math.min(reconnectFrequencySeconds * 2, 30);
      setTimeout(() => {
        setupEventSource();
      }, reconnectFrequencySeconds * 1000);
    };

    const fetchData = async () => {
      const response = await RequestServer(url, "GET");
      if (response.data) {
        setData(response.data);
      }
    }

    const setupEventSource = () => {
      eventsource = new EventSource(
        HOSTURL_LOCAL + APIRoutes.NOTIFICATIONS + "/events?user_id=" + getUserId(),
      );
      eventsource.addEventListener("connected", fetchData);
      eventsource.addEventListener("notification received", async () => {
        enqueueSnackbar("New Notification Received", {
          variant: "success"
        })
        await fetchData()
      });
      eventsource.onerror = () => {
        console.error("EventSource failed.");
        eventsource?.close();
        reconnect();
      };
    };

    setupEventSource();

    return () => {
      eventsource?.close(); // 🔥 clean up on unmount
    };
  }, [url]);

  return (
    <Box sx={{ position: "relative" }}>
      <IconButton
        id="notifications-button"
        onClick={handleClick}
        color="inherit"
        aria-label="open drawer"
        edge="start"
        disableRipple
        sx={{ marginX: "auto" }}
      >
        <Badge
          badgeContent={
            data.filter((notification: any) => !notification.read_on).length
          }
          color="error"
        >
          <NotificationsNone />
        </Badge>
      </IconButton>
      <NotificationsList
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        data={data}
        setData={setData}
      />
    </Box>
  );
}
